<template>
  <v-app>
    <v-layout row justify-center>
      <v-flex class="pl-4 pr-4 mt-3 mb-4" xs12 sm11>
        <v-card>
          <v-toolbar color="grey" dark dense>
            <v-toolbar-title>Juzgados
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="800px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn color="grey darken-2" dark class="mb-2" v-on="on">Nuevo</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field class="no-truncate" v-model.trim="editedItem.nombre"  label="Nombre" :rules="notBlankRules">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model.trim="editedItem.clave" label="Clave" :rules="claveRules" maxlength="5" counter="5">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-autocomplete
                            v-model.trim="editedItem.municipio_id"
                            label="Municipio"
                            :items="listMunicipios"
                            item-text="nombre"
                            item-value="id"
                            :rules="notBlankRules">
                          </v-autocomplete>
                        </v-flex>
                        <v-flex xs12>
                          <v-select
                            v-model.trim="editedItem.materia_id"
                            label="Materia"
                            :items="listMaterias"
                            item-text="nombre"
                            item-value="id"
                            :rules="notBlankRules">
                          </v-select>
                        </v-flex>
                        <v-flex xs12>
                          <v-checkbox
                            v-if="editedIndex > -1"
                            v-model="activo"
                            label="Activo"
                            :value="activo"
                          ></v-checkbox>
                        </v-flex>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="red darken-1" dark @click.native="close">Cancelar</v-btn>
                          <v-btn v-if="editedIndex > -1" class="ma-2 white--text" color="yellow darken-2" @click.native="editJuzgado(editedItem)" :disabled="!valid" :loading="loading">Guardar</v-btn>
                          <v-btn v-else class="ma-2 white--text" color="yellow darken-2" @click.native="addJuzgado(editedItem)" :disabled="!valid" :loading="loading">Guardar</v-btn>
                        </v-card-actions>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog><!-- end dialog edit o save-->
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :items="listJuzgados"
            class="elevation-1 "
            light
            actions
            :loading="loading"
            :items-per-page="itemsPerPage"
            hide-default-footer
            @page-count="pageCount = $event"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-autocomplete
                  class="mx-4 mt-8"
                  return-object
                  item-text="nombre"
                  item-value="id"
                  :items="listMunicipios"
                  v-model="municipioFilter"
                  label="Filtrar por Municipio"
                  clearable
                  @change="onFilterChange"
                ></v-autocomplete>
              </v-toolbar>
            </template>
            <template v-slot:item.activo="{ item }">
              <v-icon
                  v-if="!item.deleted_at"
                  class="mr-2"
                  color="green"
                >
                  mdi-check-bold
              </v-icon>
              <v-icon
                  v-else
                  class="mr-2"
                  color="grey"
                >
                  mdi-minus
              </v-icon>
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon
              color="orange"  class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon
              v-if="!item.deleted_at" color="red"  @click="deleteJuzgado(item)">mdi-close</v-icon>
              <!--<v-icon dark>mdi-folder-settings-variant</v-icon>-->
            </template>
          </v-data-table>
          <div class="text-center pt-2" v-if="pagination.total > 1">
            <v-pagination 
              v-model="pagination.current_page" 
              :length="pagination.total"
              :total-visible="7"
              @input="onPageChange"
            >
            </v-pagination>
          </div>
        </v-card>
      </v-flex>
    </v-layout>

  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
const Swal = require('sweetalert2');
export default {

  data() {
    return {
      pagination: { 
        current_page: 1,
        total: 0,
      },
      itemsPerPage: 20,
      valid: true,
      dialog: false,
      loading:false, //component
      show: false,
      headers: [
        { text: 'Id', value: 'id', sortable: true },
        { text: 'Nombre', value: 'nombre', sortable: true },
        { text: 'Municipio', value: 'municipio_data.nombre', sortable: true },
        { text: 'Materia', value: 'materia_data', sortable: true },
        { text: 'Clave', value: 'clave', sortable: false },
        { text: 'Activo', value: 'activo', sortable: false },
        { text: 'Acciones', value: 'action', width: '15%', sortable: false }
      ],
      editedIndex: -1,
      activo: true,
      listJuzgados: [],
      listMaterias: [],
      editedItem: {
        municipio_id:'',
        materia_id:'',
        nombre:'',
        clave:'',
      },
      defaultItem: {
        municipio_id:'',
        materia_id:'',
        nombre:'',
        clave:'',
      },
      /* filters */
      municipioFilter: null,
      /* end filters */
      // message: '',
      notBlankRules: [v => !!v || 'Este campo es requerido'],
      claveRules: [
        v => !!v || 'Este campo es requerido',
        v => (v && v.length <= 5) || 'Máximo 5 caracteres',
      ]
    }
  },
  watch: {
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Juzgado' : 'Editar Juzgado'
    },
    ...mapGetters([
      "permisosList", "listMunicipios"
    ]),
  },
  mounted() {
    this.getJuzgados();
    this.getMunicipios();
    this.getMaterias();
  },
  methods: {
    getJuzgados() {
      this.loading = true;
      let params = '';
      if (this.municipioFilter && this.municipioFilter.id) {
        params = '&municipio_id=' + this.municipioFilter.id;
      }
      this.$store.dispatch("LIST_JUZGADOS",  { url: "/listJuzgados?page=" + this.pagination.current_page + params } ).then(response => {
        this.pagination.current_page = response.data.data.juzgados.current_page;
        this.pagination.total = response.data.data.juzgados.last_page;
        this.listJuzgados = response.data.data.juzgados.data;
        this.loading = false;
      })
      .catch(err => {
        console.log(err);
      });
    },
    onPageChange() {
      this.getJuzgados();
    },
    onFilterChange() {
      this.pagination.current_page = 1;
      this.getJuzgados();
    },
    getMunicipios() {
      this.$store.dispatch("GET_MUNICIPIOS",  { url: "/municipios" } ).then(response => {
      })
      .catch(err => {
        console.log(err);
      });
    },
    getMaterias() {
      this.$store.dispatch("LIST_JUZGADOS",  { url: "/materias" } ).then(response => {
        this.listMaterias = response.data.data.materias;
      })
      .catch(err => {
        console.log(err);
      });
    },

    editItem (item) {
      this.editedIndex = this.listJuzgados.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.nombre = this.editedItem.nombre.split(' (')[0]
      this.dialog = true
      if (this.editedItem.deleted_at) {
        this.activo = false
      }else {
        this.activo = true
      }
    },

    addJuzgado(){
      if (this.$refs.form.validate()) {
        this.loading = true;
        var data = this.editedItem;
        this.$store.dispatch("SAVE_JUZGADO",  { url: "/juzgado", data: data } ).then(response => {
          this.close ();
          Swal.fire({
            icon: 'success',
            title: 'Se Guardó Correctamente',
            confirmButtonText: "Aceptar"
          })
          this.getJuzgados();
        })
        .catch(error => {
          console.log(error.response.data);
          if(error.response.data.status){
            Swal.fire({
              icon: 'error',
              title: 'Error',
              title: error.response.data.msg,
              confirmButtonText: "Aceptar"
            })
          }else{
            Swal.fire({
              icon: 'error',
              title: error.response.data.message,
              text: error.response.data.errors,
              confirmButtonText: "Aceptar"
            })
          }
        });
      }
      this.loading = false;
    },

    editJuzgado(item){
      //this.dialog=false;
      item.activo = this.activo
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store.dispatch("EDIT_JUZGADO",  { url: "/juzgado/" + item.id, data: item } ).then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Juzgado actualizado correctamente.',
            confirmButtonText: "Aceptar"
          })
          this.getJuzgados();
        })
        .catch(error => {
          console.log(error);
          if(error.response.data){
            Swal.fire({
              icon: 'error',
              title: error.response.data.message,
              text:  error.response.data.errors,
              confirmButtonText: "Aceptar"
            })
          }else{
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: error.response.data.status,
              confirmButtonText: "Aceptar"
            })
          }
        });
        this.loading = false;
        this.close()
      }
    },

    deleteJuzgado(item){
      this.$swal({
        title: '¿Desea eliminar Juzgado ' + item.nombre + '?',
        text: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: "Aceptar"
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("DELETE_JUZGADO",  { url: "/juzgado/" + item.id } ).then(res => {
            Swal.fire({
              icon: 'success',
              title: 'Juzgado eliminado correctamente.',
              confirmButtonText: "Aceptar"
            })
            this.getJuzgados();
          })
          .catch(err => {
            console.log(err);
          });
        }
      })
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.$refs.form.reset()
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.dialog = false
      }, 300)
    },

  }
}
</script>
<style scoped>
.no-truncate {
  white-space: normal;
  overflow: visible;
  text-overflow: initial;
  margin-bottom: -25px;
  margin-top:10px
}



</style>